import React, { Component } from 'react'
import MaterialAppBar from 'material-ui/AppBar'
import Toolbar from 'material-ui/Toolbar'
import Typography from 'material-ui/Typography'
import AppMenu from '../AppMenu'
import Tabs, { Tab } from 'material-ui/Tabs'

class AppBar extends Component<void> {
  handleChangeTab = (e, tabValue) => {
    this.props.history.push(tabValue)
  }

  render () {
    const {
      location: {
        pathname
      }
    } = this.props

    return (
      <MaterialAppBar position='static'>
        <Toolbar disableGutters className='ml3'>
          <Typography
            variant='title'
            color='inherit'
            className='flex-auto'
          >
            City Council of Toronto
          </Typography>

          <AppMenu />
        </Toolbar>

        <Tabs
          value={pathname}
          onChange={this.handleChangeTab}
          centered
          fullWidth
        >
          <Tab label='Overview' value='/toronto' />
          <Tab label='Councillors' value='/toronto/councillors' />
        </Tabs>
      </MaterialAppBar>
    )
  }
}

export default AppBar



// WEBPACK FOOTER //
// ./src/components/AppBar/AppBar.js